import "../../styles/main.scss";
import App from './App.svelte';
import { Header, Navbar, Footer } from '$lib';
import { setupI18n } from "../../../../helpers/i18n.js";
import { initialCountry } from "../store/globalStore.js";

// Contenido principal
const app = new App({
  target: document.getElementById('content')
});

// Instancia del header fijo
new Header({
  target: document.getElementById('header'),
});

// Esperar a que i18n esté listo antes de instanciar la navbar
setupI18n(initialCountry).then(() => {
  // Instancia de la navbar lateral
  new Navbar({
    target: document.getElementById('navbar'),
    props: {
      selected: 'prices'
    }
  });
});

new Footer({
  target: document.getElementById('footer'),
});

export default app;